/** Convierte cualquier URL común de YouTube en una embebible, o null si no es YouTube. */
export function youtubeEmbed(url: string): string | null {
  try {
    const u = new URL(url.trim());
    const host = u.hostname.replace(/^www\./, '');
    let id: string | null = null;
    if (host === 'youtu.be') id = u.pathname.slice(1);
    else if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      if (u.pathname === '/watch') id = u.searchParams.get('v');
      else if (u.pathname.startsWith('/embed/')) id = u.pathname.split('/')[2] ?? null;
      else if (u.pathname.startsWith('/shorts/')) id = u.pathname.split('/')[2] ?? null;
      else if (u.pathname.startsWith('/live/')) id = u.pathname.split('/')[2] ?? null;
    }
    if (!id) return null;
    return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`;
  } catch {
    return null;
  }
}
